export function getPreviewMessage(channelType, messageJson) {
  try {
    if (!channelType || !messageJson?.messages?.length) return "";

    const first = messageJson.messages[0];

    let raw;

    switch (channelType) {
      case "whatsapp_api":
      case "whatsapp_web":
        raw = first?.message?.content;
        break;

      case "email":
        raw = first?.message?.content;
        break;

      case "sms":
        raw = first?.message;
        break;

      default:
        raw = "";
    }

    if (typeof raw === "object") {
      return raw?.content || "";
    }

    return raw || "";
  } catch (error) {
    console.error("Erro ao extrair preview:", error);
    return "";
  }
}

export function truncateText(text, limit = 30) {
  if (!text) return "";
  return text.length > limit ? text.slice(0, limit) + "..." : text;
}
